import { Auth } from '../config/configuration/react';
import { countries } from '../config';

export const currencySign = (value = '', country = null, posCountry = null) => {
  let userCountry = Auth.country();
  if (country !== null) {
    userCountry = country;
  }

  let currency = userCountry === 'UK' ? '£' : '€';
  if (posCountry) currency = countries[posCountry] === 'UK' || posCountry === 'UK' ? '£' : '€';
  if (userCountry === 'UK') return `${currency} ${value}`;
  return `${value} ${currency}`;
};
